import * as env from 'src/lib/env';

import { openOAuthPopup } from './utils';

const AUTH_URL = `${env.getBackendRootUrl()}/saml/sign_in`;

export const loginWithSSO = (email: string) => {
  return openOAuthPopup(`${AUTH_URL}?email=${email}`);
};
